export const GIFT_CARD_QUERY_KEY = 'gift-cards-data';
